module.exports = __webpack_public_path__ + "img/perimeter-company-no-data.d132c828.svg";